module.exports = __webpack_public_path__ + "img/sld_scb_3_green.d95b00a4.svg";